import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';

import { FullPageWidth } from '../../components/global/FullPageWidth/FullPageWidth.tsx';

import dibsCss from 'dibs-css';
import cn from 'classnames';
import styles from './SbSharedContentModuleStorytelling.scss';

import { type SbSharedContentModuleStorytellingHeader_browseContentModule$key } from './__generated__/SbSharedContentModuleStorytellingHeader_browseContentModule.graphql.ts';

const storytellingBrowseContentModuleFragment = graphql`
    fragment SbSharedContentModuleStorytellingHeader_browseContentModule on ContentModuleStorytelling {
        eyeBrowText
        title
        subtitle
        storytellingHeaderColor
        storytellingHeaderTextColor
    }
`;

type Props = {
    browseContentModule: SbSharedContentModuleStorytellingHeader_browseContentModule$key;
    isMobile?: boolean;
};

const DEFAULT_BG = '#ffffff';
const DEFAULT_TEXT_COLOR = '#000000';

export const SbSharedContentModuleStorytellingHeader: FC<Props> = ({
    browseContentModule: browseContentModuleRef,
    isMobile = false,
}) => {
    const browseContentModule = useFragment(
        storytellingBrowseContentModuleFragment,
        browseContentModuleRef
    );

    const { eyeBrowText, title, subtitle, storytellingHeaderColor, storytellingHeaderTextColor } =
        browseContentModule || {};
    const headerBg = storytellingHeaderColor || DEFAULT_BG;
    const headerColor = storytellingHeaderTextColor || DEFAULT_TEXT_COLOR;

    return (
        <FullPageWidth className={cn({ [dibsCss.mbLarge]: !isMobile })}>
            <div
                className={cn({ [styles.header]: !isMobile })}
                style={{ backgroundColor: headerBg, color: headerColor }}
            >
                {/* breadcrumbs offset from the top of the page */}
                {!isMobile && <div style={{ height: '36px' }} />}
                <div
                    className={cn(
                        dibsCss.textCenter,
                        { [dibsCss.pLarger]: !isMobile, [dibsCss.pMedium]: isMobile },
                        dibsCss.ptMedium,
                        dibsCss.flex,
                        dibsCss.flexCol,
                        dibsCss.gapXxsmall
                    )}
                >
                    {eyeBrowText && (
                        <span
                            className={cn({
                                [dibsCss.sassyFontHeaderMediumItalic]: !isMobile,
                                [dibsCss.sassyFontHeaderSmallItalic]: isMobile,
                            })}
                        >
                            {eyeBrowText}
                        </span>
                    )}
                    {title && (
                        <div
                            className={cn({
                                [dibsCss.sassyFontHeaderBannerSmallNormal]: !isMobile,
                                [dibsCss.sassyFontHeaderLarge]: isMobile,
                            })}
                        >
                            {title}
                        </div>
                    )}
                    {subtitle && (
                        <p
                            className={cn({
                                [dibsCss.sassyFontBodyMedium]: !isMobile,
                                [dibsCss.sassyFontBodySmall]: isMobile,
                            })}
                        >
                            {subtitle}
                        </p>
                    )}
                </div>
            </div>
        </FullPageWidth>
    );
};
